module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "under-bg"
  }, [_c('c-content', [_c('div', {
    staticClass: "text-center active-success"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_c('i', {
    staticClass: "success-color s-icon-check-circle-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "success-color font-lg"
  }, [_vm._v("激活成功")]), _vm._v(" "), _c('div', {
    staticClass: "mt-15 text-color gray font-md"
  }, [_vm._v("请推荐用户扫描收款码，进行付款。")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82e629b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/active-payment/success/index.vue
// module id = 384
// module chunks = 0